var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": "medium-fade",
      "mode": "out-in"
    }
  }, [_vm.activeTags.length ? _c('div', {
    staticClass: "reference-slider",
    class: [{
      'reference-slider--vert': _vm.isVertical
    }, {
      'reference-slider--sub-bottom-bar': _vm.isSubBottomBarVisible
    }, {
      'reference-slider--sub-bottom-bar-stack': _vm.isSubBottomBarStacked
    }, {
      'reference-slider--video-active': _vm.isVideoActive
    }]
  }, [_c('div', {
    staticClass: "tag-slider-controls",
    attrs: {
      "id": _vm.controlsId
    }
  }, [_c('div', {
    staticClass: "tag-slider-prev",
    attrs: {
      "data-controls": "prev"
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fal', 'chevron-left']
    }
  })], 1), _c('div', {
    staticClass: "tag-slider-next",
    attrs: {
      "data-controls": "next"
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fal', 'chevron-right']
    }
  })], 1)]), _c('div', {
    staticClass: "reference-container touch"
  }, [_c('tiny-slider', _vm._b({
    key: _vm.sliderKey,
    ref: "tinySlider",
    staticClass: "touch",
    attrs: {
      "startIndex": _vm.activeLanguage.dir === 'rtl' ? _vm.activeTags.length - 1 : 0
    },
    on: {
      "dragMove": _vm.handleSliderDrag,
      "dragEnd": _vm.handleSliderDragEnd
    }
  }, 'tiny-slider', _vm.isVertical ? _vm.verticalTinySliderOptions : _vm.tinySliderOptions, false), _vm._l(_vm.activeTags, function (tag) {
    return _c('div', {
      key: tag._id
    }, [_c('div', {
      staticClass: "slide",
      class: {
        'slide--reverse': _vm.activeLanguage.dir === 'rtl'
      }
    }, [_c('div', {
      staticClass: "slide__image-wrapper",
      class: tag.image === '' ? 'no-image' : null
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: tag.isVisible,
        expression: "tag.isVisible"
      }],
      staticClass: "slide__image-reference"
    }, [_vm._v(_vm._s(tag.referenceIndex))]), _c('img', {
      staticClass: "slide__image",
      class: tag.image === '' ? 'no-image' : null,
      attrs: {
        "src": _vm.getAsset(tag),
        "alt": ""
      }
    }), tag.asset && tag.asset.type === 'video' ? _c('div', {
      staticClass: "slide__video-circle-wrapper",
      class: {
        'slide__video-circle-wrapper--active': tag.asset.path === _vm.video
      }
    }, [_c('fa', {
      attrs: {
        "icon": ['fad', 'play-circle']
      },
      on: {
        "click": function click($event) {
          return _vm.setVideo(tag.asset.path);
        }
      }
    })], 1) : _vm._e()]), _c('div', {
      staticClass: "slide__content",
      class: {
        'dir-rtl': _vm.activeLanguage.dir === 'rtl'
      }
    }, [_c('div', {
      staticClass: "slide__heading",
      domProps: {
        "innerHTML": _vm._s(tag.label[_vm.activeLanguage.code])
      }
    }), _c('div', {
      staticClass: "slide__description",
      domProps: {
        "innerHTML": _vm._s(tag.description[_vm.activeLanguage.code])
      }
    })])])]);
  }), 0)], 1)]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.video ? _c('div', {
    staticClass: "reference-video touch",
    class: [{
      'reference-video--vert': _vm.isVertical
    }, {
      'reference-video--sub-bottom-bar': _vm.isSubBottomBarVisible
    }],
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('div', {
    staticClass: "reference-video__container touch",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('video', {
    attrs: {
      "src": _vm.$store.state.assetsPath + _vm.video,
      "autoplay": "",
      "loop": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    }
  })])]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }